import { render, staticRenderFns } from "./EditReactAside.vue?vue&type=template&id=465d3bc8&scoped=true&"
import script from "./EditReactAside.vue?vue&type=script&lang=js&"
export * from "./EditReactAside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465d3bc8",
  null
  
)

export default component.exports